// adminService.js
import { getAuth } from 'firebase/auth';

const API_BASE_URL = process.env.REACT_APP_API_SUPORTE_URL;

/**
 * Verifica se o usuário possui o papel de admin no backend.
 * - Anexa o Firebase ID token no header Authorization: Bearer <token>.
 * - Retorna sempre um booleano.
 */
export const verificarAdmin = async (uid) => {
  // 1) Validação rápida para evitar request inútil
  if (!uid) {
    console.error('UID do usuário não fornecido para verificarAdmin.');
    return false;
  }

  try {
    // 2) Pega o ID token atual do usuário logado (o SDK renova se precisar)
    const auth = getAuth();
    const user = auth.currentUser;
    const idToken = user ? await user.getIdToken() : null;
    if (!idToken) throw new Error('Sem ID token');

    // 3) Chamada à API com Authorization: Bearer <idToken>
    const res = await fetch(`${API_BASE_URL}/is-admin/${encodeURIComponent(uid)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`, // ou 'ClientAuthorization': idToken
      },
    });

    // 4) Trata status não OK (401 sem token/expirado; 403 sem permissão)
    if (!res.ok) {
      // Opcional: diferenciar por status para UX melhor
      // if (res.status === 401) console.warn('Não autenticado');
      // if (res.status === 403) console.warn('Sem permissão de admin');
      throw new Error(`Erro na resposta da API: Status ${res.status}`);
    }

    // 5) Extrai JSON e garante booleano
    const data = await res.json();
    return data.admin === true;
  } catch (error) {
    console.error('Erro ao verificar status de admin:', error);
    return false;
  }
};
